import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import { switch_base_css, getStyleByProps } from './styles';

export type SwitchSize = 'small' | 'medium' | 'large';

export interface SwitchProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** @default true */
  isOn?: boolean;
  /** @default 'small' */
  size?: SwitchSize;
  width?: number;
  /** @default 'ON' */
  onText?: string;
  /** @default 'OFF' */
  offText?: string;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ isOn = true, size = 'small', onText = 'ON', offText = 'OFF', width, className, ...props }, ref) => (
    <button
      type='button'
      className={classNames('pds-switch', className)}
      css={[switch_base_css, getStyleByProps({ size, isOn, width, hasLabel: Boolean(onText) && Boolean(offText) })]}
      ref={ref}
      role='switch'
      aria-checked={isOn}
      {...props}
    >
      <span aria-hidden>{isOn ? onText : offText}</span>
    </button>
  ),
);
